module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c696bfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paypalButton.vue
// module id = 293
// module chunks = 1